import websiteIcon from 'dashboard/assets/images/channels/website.svg';
import whatsappIcon from 'dashboard/assets/images/channels/whatsapp.svg';
import emailIcon from 'dashboard/assets/images/channels/email.svg';
import smsIcon from 'dashboard/assets/images/channels/sms.svg';
import telegramIcon from 'dashboard/assets/images/channels/telegram.svg';
import messengerIcon from 'dashboard/assets/images/channels/messenger.svg';
import { INBOX_TYPES } from 'dashboard/helper/inbox';

const CHANNEL_ICONS = {
  [INBOX_TYPES.WEB]: websiteIcon,
  [INBOX_TYPES.WHATSAPP]: whatsappIcon,
  [INBOX_TYPES.EMAIL]: emailIcon,
  [INBOX_TYPES.SMS]: smsIcon,
  [INBOX_TYPES.TWILIO]: smsIcon,
  [INBOX_TYPES.TELEGRAM]: telegramIcon,
  [INBOX_TYPES.FB]: messengerIcon,
};

// Branded channel-type icon (from sumo-standalone) for a given Chatwoot
// channel_type. Falls back to the website icon for unknown/other channels.
export function channelImageFor(channelType, medium) {
  if (!channelType) {
    return null;
  }
  if (channelType === INBOX_TYPES.TWILIO && medium === 'whatsapp') {
    return whatsappIcon;
  }
  return CHANNEL_ICONS[channelType] || websiteIcon;
}

export default channelImageFor;
